import { useMemo } from 'react';
import { Connection, PublicKey } from '@solana/web3.js';
import { CLUSTER_URL, MONOPOLY_MINT, PROGRAM_ID, ROLL_MINT, WS_CLUSTER_URL } from '../constants';

export function useProgram() {
  const programId = useMemo(() => new PublicKey(PROGRAM_ID!), []);
  const monopolyMint = useMemo(() => new PublicKey(MONOPOLY_MINT!), []);
  const rollMint = useMemo(() => new PublicKey(ROLL_MINT!), []);

  const connection = useMemo(() => {
    const endpoint = CLUSTER_URL;
    return new Connection(endpoint, { wsEndpoint: WS_CLUSTER_URL });
  }, []);

  return { connection, programId, monopolyMint, rollMint };
}

